import {css} from "@panda/css";

import {IFieldErrorMessageVariant, MAX_VALUE_INPUT_LIMITER} from "@pg-design/inputs-module";
import {MaxValueFieldControlled} from "@pg-design/rhf-components-module";

import {PRICE_FIELD_CONTENT} from "./constants/price_field_content";
import {PRICE_FIELD_CENTER_VALUE, PRICE_FIELD_DEFAULT_MAX, PRICE_FIELD_MIN, PRICE_FIELD_STEP} from "./constants/price_field_defaults";

interface IClassNames {
    amount?: string;
    field?: string;
    input?: string;
    inputWrap?: string;
    inputWrapper?: string;
    root?: string;
}

interface IProps {
    allowUnlimitedLabel?: boolean;
    classNames?: IClassNames;
    errorMessageVariant?: IFieldErrorMessageVariant;
    name: string;
    placeholder?: string;
    showPlaceholderAtMin?: boolean;
    value?: number;
}

const getMax = (value?: number) => {
    if (value && value < MAX_VALUE_INPUT_LIMITER) {
        return Math.max(value, PRICE_FIELD_DEFAULT_MAX);
    }

    return PRICE_FIELD_DEFAULT_MAX;
};

export const PriceField = (props: IProps) => {
    const {allowUnlimitedLabel = true, classNames, errorMessageVariant, name, placeholder, showPlaceholderAtMin, value} = props;
    const {CURRENCY_SUFFIX, UNLIMITED_LABEL} = PRICE_FIELD_CONTENT;

    const maxDisplayLabel = allowUnlimitedLabel ? UNLIMITED_LABEL : undefined;

    return (
        <div className={classNames?.root ?? priceFieldContainerStyle}>
            <MaxValueFieldControlled
                amountFieldClassName={classNames?.amount}
                centerValue={PRICE_FIELD_CENTER_VALUE}
                className={classNames?.field}
                errorMessageVariant={errorMessageVariant}
                inputClassName={classNames?.input ?? inputStyle}
                inputWrapClassName={classNames?.inputWrap}
                inputWrapperClassName={classNames?.inputWrapper}
                isDynamicStep
                max={getMax(value)}
                min={PRICE_FIELD_MIN}
                name={name}
                rightElement={CURRENCY_SUFFIX}
                showPlaceholderAtMin={showPlaceholderAtMin}
                step={PRICE_FIELD_STEP}
                {...(maxDisplayLabel !== undefined && {maxDisplayLabel})}
                {...(placeholder !== undefined && {placeholder})}
            />
        </div>
    );
};

const inputStyle = css({
    width: "7.5rem"
});

const priceFieldContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: 2
});
import {css} from "@panda/css";

import {IFieldErrorMessageVariant, MAX_VALUE_INPUT_LIMITER} from "@pg-design/inputs-module";
import {MaxValueFieldControlled} from "@pg-design/rhf-components-module";

import {PRICE_FIELD_CONTENT} from "./constants/price_field_content";
import {PRICE_FIELD_CENTER_VALUE, PRICE_FIELD_DEFAULT_MAX, PRICE_FIELD_MIN, PRICE_FIELD_STEP} from "./constants/price_field_defaults";

interface IClassNames {
    amount?: string;
    field?: string;
    input?: string;
    inputWrap?: string;
    inputWrapper?: string;
    root?: string;
}

interface IProps {
    allowUnlimitedLabel?: boolean;
    classNames?: IClassNames;
    errorMessageVariant?: IFieldErrorMessageVariant;
    name: string;
    placeholder?: string;
    showPlaceholderAtMin?: boolean;
    value?: number;
}

const getMax = (value?: number) => {
    if (value && value < MAX_VALUE_INPUT_LIMITER) {
        return Math.max(value, PRICE_FIELD_DEFAULT_MAX);
    }

    return PRICE_FIELD_DEFAULT_MAX;
};

export const PriceField = (props: IProps) => {
    const {allowUnlimitedLabel = true, classNames, errorMessageVariant, name, placeholder, showPlaceholderAtMin, value} = props;
    const {CURRENCY_SUFFIX, UNLIMITED_LABEL} = PRICE_FIELD_CONTENT;

    const maxDisplayLabel = allowUnlimitedLabel ? UNLIMITED_LABEL : undefined;

    return (
        <div className={classNames?.root ?? priceFieldContainerStyle}>
            <MaxValueFieldControlled
                amountFieldClassName={classNames?.amount}
                centerValue={PRICE_FIELD_CENTER_VALUE}
                className={classNames?.field}
                errorMessageVariant={errorMessageVariant}
                inputClassName={classNames?.input ?? inputStyle}
                inputWrapClassName={classNames?.inputWrap}
                inputWrapperClassName={classNames?.inputWrapper}
                isDynamicStep
                max={getMax(value)}
                min={PRICE_FIELD_MIN}
                name={name}
                rightElement={CURRENCY_SUFFIX}
                showPlaceholderAtMin={showPlaceholderAtMin}
                step={PRICE_FIELD_STEP}
                {...(maxDisplayLabel !== undefined && {maxDisplayLabel})}
                {...(placeholder !== undefined && {placeholder})}
            />
        </div>
    );
};

const inputStyle = css({
    width: "7.5rem"
});

const priceFieldContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: 2
});
